import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/empleado/getIngresosTotalesEmpleado.php';

export default function getIngresosTotalesEmpleado({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}